type Listener = () => void;
const listeners = new Map<string, Set<Listener>>();
export function subscribeTag(tag: string, listener: Listener): () => void {
  let set = listeners.get(tag);
  if (!set) {
    set = new Set();
    listeners.set(tag, set);
  }
  set.add(listener);
  return () => {
    const current = listeners.get(tag);
    if (current === undefined) return;
    current.delete(listener);
    if (current.size === 0) listeners.delete(tag);
  };
}
export function invalidateTags(tags: readonly string[]): void {
  const unique = new Set<Listener>();
  for (const tag of tags) {
    const set = listeners.get(tag);
    if (set === undefined) continue;
    for (const listener of set) unique.add(listener);
  }
  for (const listener of unique) listener();
}
